@if (cards.length) {
  <div class="flex items-baseline justify-between gap-3 mb-2">
    <h2 class="text-primary-title text-2xl font-semibold">
      {{ 'home.attention.title' | translate }}
    </h2>
    <button type="button" (click)="seeAll()" class="shrink-0 text-sm font-semibold text-primary">
      {{ 'home.attention.see-all' | translate }} &rsaquo;
    </button>
  </div>

  <!-- Défilement horizontal, débordant des marges de la page : la carte
       coupée au bord droit est ce qui dit qu'il y en a d'autres. -->
  <div class="-mx-4 flex snap-x snap-mandatory scroll-pl-4 scroll-pr-4 gap-3 overflow-x-auto px-4 pb-1">
    @for (card of cards; track card.plantUid) {
      <button type="button" (click)="open(card)"
        class="w-[104px] shrink-0 snap-start overflow-hidden rounded-2xl bg-white text-left shadow-sm active:scale-[0.98] transition">
        <div class="relative h-[78px] w-full bg-[#EAF5EF]">
          @if (card.imageUrl) {
            <img [src]="card.imageUrl" [alt]="card.name" class="h-full w-full object-cover">
          } @else {
            <span class="flex h-full w-full items-center justify-center text-3xl">🌱</span>
          }
          <!-- La pastille du besoin sur l'image : elle se lit avant le nom. -->
          <span class="absolute right-1.5 top-1.5 flex h-6 w-6 items-center justify-center rounded-full text-xs shadow-sm"
            [style.background-color]="card.need.background">
            {{ card.need.emoji }}
          </span>
        </div>

        <div class="p-2">
          <p class="truncate text-xs font-semibold text-[#023E42]">{{ card.name }}</p>
          @if (card.locationName) {
            <p class="truncate text-[10px] text-[#9BA5A1]">{{ card.locationName | locationLabel }}</p>
          }
          <span class="mt-1 block w-full truncate rounded-full px-1.5 py-0.5 text-center text-[10px] font-semibold"
            [style.background-color]="card.need.background"
            [style.color]="card.need.ink">
            {{ 'home.attention.needs.' + card.need.key | translate }}
          </span>
        </div>
      </button>
    }
  </div>
}
